import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useState, useEffect } from 'react';
import Panel from './panel';
import DefaultTheme from './theme';
export var AccordionTheme = DefaultTheme;
/*::
import type { Node } from 'react';
import type { StyledComponent } from 'styled-components';
import type { ThemeType as PanelTheme } from './panel';

export type ThemeType = {|
  Main: * => StyledComponent,
  Panel: PanelTheme
|};

export type JsxPanel = {|
  head: Node | Array<Node>,
  body: Node | Array<Node>,
|};

type Props = {|
  jsxPanels: Array<JsxPanel>,
  activePanel?: number,
  multipleActivePanels?: null | number[],
  forceHeightRecalculation?: boolean,
  scrollToPanel?: number,
  theme?: ThemeType,
  rest?: any,
|}
*/

/*
 forceHeightRecalculation usecase example:
 Accordion is used inside tabs and on each tab we have another
 accordion. For the inactive tabs corresponding accordions will have
 display: none;
 which results in height equals 0 always.
 And when tab gets activated height will remain 0 because height calculation
 only happens on mount. forceHeightRecalculation forces height
 recalculation when this prop changes.
*/

var Accordion = function Accordion(_ref
/*: Props */
) {
  var _ref$jsxPanels = _ref.jsxPanels,
      jsxPanels = _ref$jsxPanels === void 0 ? [] : _ref$jsxPanels,
      _ref$activePanel = _ref.activePanel,
      activePanel = _ref$activePanel === void 0 ? 0 : _ref$activePanel,
      _ref$multipleActivePa = _ref.multipleActivePanels,
      multipleActivePanels = _ref$multipleActivePa === void 0 ? null : _ref$multipleActivePa,
      forceHeightRecalculation = _ref.forceHeightRecalculation,
      _ref$scrollToPanel = _ref.scrollToPanel,
      scrollToPanel = _ref$scrollToPanel === void 0 ? -1 : _ref$scrollToPanel,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["jsxPanels", "activePanel", "multipleActivePanels", "forceHeightRecalculation", "scrollToPanel", "theme"]);

  var _useState = useState(activePanel),
      activePanelIndex = _useState[0],
      setActivePanelIndex = _useState[1];

  var _useState2 = useState(scrollToPanel),
      scrollToPanelIndex = _useState2[0],
      setScrollToPanelIndex = _useState2[1];

  var _useState3 = useState(multipleActivePanels || [activePanel]),
      activePanelIndices = _useState3[0],
      setActivePanelIndices = _useState3[1];

  useEffect(function () {
    setActivePanelIndex(activePanel);

    if (multipleActivePanels) {
      setActivePanelIndices(_toConsumableArray(multipleActivePanels));
    }
  }, [activePanel, multipleActivePanels]);
  useEffect(function () {
    setScrollToPanelIndex(scrollToPanel);
  }, [scrollToPanel]);
  return /*#__PURE__*/React.createElement(theme.Main, rest, jsxPanels.map(function (_ref2, index) {
    var head = _ref2.head,
        body = _ref2.body;
    return /*#__PURE__*/React.createElement(Panel // eslint-disable-next-line
    , {
      key: index,
      isActive: multipleActivePanels ? activePanelIndices.includes(index) : activePanelIndex === index,
      head: head,
      body: body,
      activatePanel: function activatePanel() {
        if (multipleActivePanels) {
          if (activePanelIndices.includes(index)) {
            var filteredPanels = activePanelIndices.filter(function (i) {
              return i !== index;
            });
            setActivePanelIndices(filteredPanels);
          } else {
            setActivePanelIndices([].concat(_toConsumableArray(activePanelIndices), [index]));
          }

          return;
        }

        setActivePanelIndex(function (prev) {
          return prev === index ? -1 : index;
        });
      },
      recalculateHeight: forceHeightRecalculation,
      scrollTo: index === scrollToPanelIndex,
      theme: theme.Panel
    });
  }));
};

export default Accordion;